import React, { Component } from 'react';
import { connect } from 'react-redux';
import Paper from '@mui/material/Paper';
import PaginatedTable from '../../components/PaginatedTable';
import Tooltip from '@mui/material/Tooltip';
import Fab from '@mui/material/Fab';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Add from '@mui/icons-material/Add';
import Delete from '@mui/icons-material/Delete';
import Edit from '@mui/icons-material/Edit';
import VpnKey from '@mui/icons-material/VpnKey';
import { showError, showMessage, confirmAction } from '../../actions/uiActions';
import AdministratorsApi from '../../api/administrators';
import Administrator from '../../forms/Administrator';
import { logout } from '../../actions/authActions';
import AssignmentInd from '@mui/icons-material/AssignmentInd';
import AssignUser from '../../forms/Administrator/assignUser';
import DomainsApi from '../../api/domains';
import { withRouter } from '../../utils/withRouter';


class Administrators extends Component {
  state = {
    administrators: [],
    page: 0,
    count: 0,
    loading: false,
    mode: 'default',
    deleting: false,
    id: null,
    account: null,
    resetting: null,
    domains:[]
  };
  componentWillMount() {
    this.load(0);
    this.getAllDomains()
  }


  async getAllDomains() {
    const domains = await DomainsApi.all();
    this.setState({
      domains: domains.map(each => ({id: each._id, name: each.company}))
    })
  }
  load = (page = 0) => {
    this.setState(
      { loading: true, searching: this.state.search ? true : false },
      () =>
        AdministratorsApi.load(page)
          .then(
            result => {
              this.setState({ loading: false, ...result });
            },
            error => {
              this.setState({ loading: false });
              this.props.showError();
            }
          )
          .catch(error => {
            this.setState({ loading: false });
            this.props.showError();
          })
    );
  };
  roleText = role => {
    switch (role) {
      case 'coach':
        return 'Student Loan Coach';
      case 'sales':
        return 'Sales Representative';
      default:
        return 'System Administrator';
    }
  };
  reset = id => {
    this.props.confirmAction(
      'You are going to reset the account password for this Administrator. Do you want to proceed?',
      () =>
        this.setState({ resetting: true, id }, () =>
          AdministratorsApi.reset(id)
            .then(
              success => {
                this.setState({ resetting: false }, () => {
                  this.props.showMessage(
                    'The Account password has been reset. An email has been sent to the administrator with the new account password.'
                  );
                  if (this.props.account.id === id) {
                    return this.props.logout()
                  }
                  this.load(this.state.page);
                });
              }
            )
            .catch(error => {
              this.setState(
                { resetting: false, id: null },
                this.props.showError
              )
            }
            )
        )
    );
  };
  delete = id => {
    if (this.props.account.id === id) {
      return this.props.confirmAction(
        "For security reasons you can't delete yourself, please contact another admin to delete your account",
        () => { },
        'Oops!',
        'Okay',
        'Close'
      );
    }
    this.props.confirmAction(
      'You are going to delete this account permanentely, therefore the user will no longer have access to this platform. Do you want to proceed?',
      () =>
        this.setState({ deleting: true, id }, () =>
          AdministratorsApi.delete(id)
            .then(
              success => {
                this.props.showMessage('The Account has been deleted');
                this.load(this.state.page);
              })
            .catch(error => {
              this.setState({ deleting: false, id: null })
              this.props.showError(error)
            }

            )
        )
    );
  };

  getSortedDomains = () => {
    const { domains } = this.state.account
    return this.state.domains.sort((a, b) => {
      const indexA = (domains || []).indexOf(a.id);
      const indexB = (domains || []).indexOf(b.id);
      if (indexA === -1 && indexB === -1) {
        return 0;
      } else if (indexA === -1) {
        return 1;
      } else if (indexB === -1) {
        return -1;
      } else {
        return indexA - indexB;
      }
    });
  }

  render() {
    return (
      <div>
        {
          (this.state.mode === 'add' || this.state.mode === 'edit') && (
            <Administrator
              domains={this.state.domains}
              account={this.state.account}
              edit={this.state.mode === 'edit'}
              onClose={() => this.setState({ mode: 'default' })}
              onUpdate={account =>{
                this.load(this.state.page);
                this.setState({
                  mode: "default",
                });
            }
              }
              onCreate={() =>
                this.setState({ mode: 'default' }, () => this.load(this.state.page))
              }
            />)

        }
        {
          this.state.mode === 'default' && (
            <section className="animated fadeIn">
              <header>
                <Tooltip
                  title="Add new Administrator"
                  placement="top"
                  className="floating-button"
                >
                  <Fab
                    onClick={() => this.setState({ mode: 'add', account: null })}
                    variant="fab"
                    color="primary"
                    aria-label="Add"
                  >
                    <Add />
                  </Fab>
                </Tooltip>
                <h1>Administrators Management</h1>
              </header>
              <Paper>
                <PaginatedTable
                  goToPage={this.load}
                  count={parseInt(this.state.count.toString())}
                  page={parseInt(this.state.page.toString())}
                  loading={this.state.loading}
                  rows={this.state.administrators.map(account => {
                    return {
                      properties: {
                        key: account.id
                      },
                      columns: [
                        {
                          properties: {
                            key: `${account.id}-1`
                          },
                          value: account.name
                        },
                        {
                          properties: {
                            key: `${account.id}-2`
                          },
                          value: account.email
                        },
                        {
                          properties: {
                            key: `${account.id}-3`
                          },
                          value: this.roleText(account.role)
                        },
                        {
                          properties: {
                            key: `${account.id}-7`,
                            className: 'text-center'
                          },
                          value: (
                            <div>
                              <Tooltip title="Edit Account">
                                <IconButton
                                  onClick={() =>
                                    this.setState({ account, mode: 'edit' })
                                  }
                                >
                                  <Edit />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Reset Account Password">
                                <IconButton onClick={() => this.reset(account._id)}>
                                  {(!this.state.resetting ||
                                    !this.state.id == account._id) && <VpnKey />}
                                  {this.state.resetting &&
                                    this.state.id == account._id && (
                                      <CircularProgress size={20} />
                                    )}
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Delete Account">
                                <IconButton onClick={() => this.delete(account._id)}>
                                  {(!this.state.deleting ||
                                    !this.state.id == account._id) && <Delete />}
                                  {this.state.deleting &&
                                    this.state.id == account._id && (
                                      <CircularProgress size={20} />
                                    )}
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Reassign Users">
                                <IconButton onClick={() => this.setState({ account, mode: 'reassign' })}>
                                  <AssignmentInd />
                                </IconButton>
                              </Tooltip>
                            </div>
                          )
                        }
                      ]
                    };
                  })}
                  emptyMessage="No administrators have been registered"
                  columns={[
                    {
                      name: 'Name',
                      properties: {
                        key: 1,
                        className: 'width25pct'
                      }
                    },
                    {
                      name: 'Email',
                      properties: {
                        key: 2,
                        className: 'width25pct'
                      }
                    },
                    {
                      name: 'Role',
                      properties: {
                        key: 3,
                        className: 'width20pct'
                      }
                    },
                    {
                      name: 'Options',
                      properties: {
                        key: 7,
                        className: 'width30pct text-center'
                      }
                    }
                  ]}
                />
              </Paper>
            </section>
          )

        }
        {
          this.state.mode === 'reassign' && (
            <section className="animated fadeIn">
              <AssignUser
                account={this.state.account}
                onClose={() => this.setState({ mode: 'default' })}
                onCreate={() =>
                  this.setState({ mode: 'default' }, () => this.load(this.state.page))
                }
                domains={this.getSortedDomains()}
              />
            </section>
          )

        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    account: state.auth.account
  };
};
export default withRouter(connect(mapStateToProps, { logout, showError, showMessage, confirmAction })(
  Administrators
));
